import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import SummaryFlights from 'components/components/common/SummaryFlights';
import axios from 'components/AppRequest';
import {
  setBookingCity
} from 'components/actions/bookingActions';

class SummaryFlightsContainer extends Component {
  state = {
    departureInfo: null,
    returnInfo: null,
    arrivalCommunicate: null
  }
  componentDidMount() {
    const { departureFlight, returnFlight, departureAddress } = this.props;
    var dfId = departureFlight ? departureFlight.id : 0;
    var rfId = returnFlight ? returnFlight.id : 0;
    if (departureAddress.selectedObject) {
      var busStopName = departureAddress.selectedObject.value;
      axios.get(`/pwa/reservation/timetable-info/${dfId}/${rfId}/${busStopName}`)
        .then(response => {
          this.setState({
            departureInfo: response.data['departure'],
            returnInfo: response.data['return'],
            arrivalCommunicate: response.data['arrivalCommunicate']
          })
        })
        .catch(err => {
          console.log("err", err);
        });
    }
  }

  render() {
    return (<SummaryFlights {...this.props} {...this.state} isSummary />);
  }
}

const mapStateToProps = (state) => {
  return {
    airportFrom: state.booking.airportFrom,
    airportTo: state.booking.airportTo,
    childrenNumber: state.booking.childrenNumber,
    city: state.booking.city,
    adultsNumber: state.booking.adultsNumber,
    seniorsNumber: state.booking.seniorsNumber,
    teenagersNumber: state.booking.teenagersNumber,
    studentsNumber: state.booking.studentsNumber,
    departureFlight: state.booking.departureFlight,
    returnFlight: state.booking.returnFlight,
    returnAddress: state.booking.returnAddress,
    departureAddress: state.booking.departureAddress,
    differentReturnAddress: state.booking.differentReturnAddress,
    cities: state.service.cities,
    locale: state.app.locale
  };
};

export default connect(mapStateToProps, { setBookingCity })(SummaryFlightsContainer);
